<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-16 15:18:25
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-01-14 17:25:56
-->
<template>
    <van-popup style="animation: all 2s;" position="bottom"  v-model="showModel"  round>
            <div class="select-popup-title">
              {{popupTitle}}
              <div v-if="page === 1" class="popup-close" style="color:#CBCCD1" @click="showModel = false"><van-icon name="cross" /></div>
              <div v-else class="popup-close" @click="page = 1">取消</div>
            </div>
          <template v-if="page === 1">
                <div class="select-popup-content">
                    <item  
                        v-for="(item,index) in dataList" :key="index" 
                        :defaultAddress="item.defaultAddress"
                        :name="item.name"
                        :address="`${item.provinceName} ${item.cityName} ${item.districtName} ${item.address}`"
                        :phone="item.phone"
                        :border="index!=0"
                        @click="onClick(item)"
                        @bntClick="update(item)"
                    />
                </div>
                <div class="select-address-button">
                    <van-button native-type="submit" color="#00BCD1" block @click="add">添加收货地址</van-button>
                </div>
          </template>
          <add v-model="addressId" v-else ref="addressAdd" @submit="onClick" @back="back" :submitText="submitText" />
    </van-popup>
</template>

<script>
import item from './components/PopupItem'
import add from './add'
export default {
    components:{item,add},
    props:{
        show:{
            type:Boolean,
            default:false
        },
        disabled:{
            type:Boolean,
            default:false
        },
        value:{
            type:[Number,String],
            default:'' 
        },
        submitText:{
            type:String,
            default:''
        }
    },
    data(){
        return{
            dataList:[],
            page:1,
        }
    },
    watch:{
        show(val){
            if(val){
                this.page = 1
                this.getDataList()
            }
        }
    },
    computed:{
        addressId:{
            get(){
                return this.value
            },
            set(val){
                this.$emit('input',val)
            }
        },
        showModel:{
            get(){
                return this.show
            },
            set(val){
                this.$emit('update:show',val)
            }
        },
        popupTitle(){
            let str = '请选择收货地址'
            if(this.page === 2){
                str = "新增收货地址"
            }
            if(this.page === 3){
                str = "编辑收货地址"
            }
            return str
        }
    },
    activated(){
        console.log('出现了')
    },
    methods:{
        init(){
            this.showModel = true
        },
        getDataList(){
            this.api.address.getList({
                page:1,
                limit:999,
                order:'desc',
                orderField:'default_address'
            }).then(({data})=>{
                this.dataList = data.list
            })
        },
        update(item){
            this.page = 3
            this.$nextTick(()=>{
                this.$refs.addressAdd.init(item.id)
            })
            // this.$router.push({
            //     path:'/address/add',
            //     query:{
            //         id:item.id
            //     }
            // }) 
        },
        add(){
            this.page = 2
            this.$nextTick(()=>{
                this.$refs.addressAdd.init()
            }) 
        },
        onClick(item){
            if(this.disabled){
                return
            }
            if(this.$listeners['click']){
                this.$emit('click',item)
            }
            // this.$store.commit('address/setHarvestAddress',item)
            // this.showModel = false
        },
        back(){
            this.page = 1
            this.getDataList()
        }
    }
}
</script>

<style scoped>
.select-popup-title{
   color: #12141A; 
   font-size: 4.8vw;
   padding: 4.6vw 3.7vw;
   text-align: center;
   font-weight: bold;
   position: relative;
}
.select-popup-content{
    height: 40vh;
    overflow: hidden;
    overflow-y: scroll;
}
.select-address-button{
    height: 16vw;
    padding: 0 4.2vw;
}
.select-address-button .button{
    background-color: #00BCD1;
    color: #ffffff;
    text-align: center;
    line-height: 13.3vw;
    height: 13.3vw;
    border-radius: 2.1vw;
    font-size: 4.2vw;
}
.popup-close{
   font-size:4.2vw;
   color: #000000;
    position: absolute;
    right: 3.7vw;
    top: 4.6vw;
}
</style>


// WEBPACK FOOTER //
// src/views/address/dialog.vue